import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom'
import Document from '../Document/Document';
import Rooms from "../Main/Rooms/Rooms";
import Room from "../Main/Rooms/Room/Room";
import NotFound from "../Main/NotFound";

interface Props {
    updateAt: moment.Moment
}

function Router(props: Props) {

    return (
        <BrowserRouter>
            <div>
                <Route exact path='/' render={()=>
                    <Rooms/>
                } />
                <Route path='/document/:title' render={url=>
                    <Document url={`/document/${url?.match?.params?.title||""}.md`} />
                } />
                <Route path="/rooms/:roomId" render={path=>
                    <Room roomId={path.match.params.roomId} />
                } />
                <Route path="/404/" render={path=>
                    <NotFound to={path.location.search} />
                } />
            </div>
        </BrowserRouter>
    )
}

export default Router;